import { FormGroup } from "@mui/material";
import { useMarketplaceStore } from "../../../../../../store/useMarketplaceStore";
import { DateRangeFilter } from "../../../../../../components/dataGridFilter/filter-components/DateRangeFilter";
import { IntegerRangeFilter } from "../../../../../../components/dataGridFilter/filter-components/IntegerRangeFilter";

export const FilterGroup4 = () => {
  const baseKey =
    "pages.inventoryManagement.inventory.list.filters.filterGroup4";
  const { selectedCountry } = useMarketplaceStore();
  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <DateRangeFilter name="created" labelKey={`${baseKey}.created`} />
      <DateRangeFilter name="updated" labelKey={`${baseKey}.updated`} />

      <IntegerRangeFilter
        name="price.finalPrice"
        labelKey={`${baseKey}.lastPrice`}
        adornment={selectedCountry?.currency}
      />
      <IntegerRangeFilter
        name="price.profit"
        labelKey={`${baseKey}.profitPrice`}
        adornment={"USD"}
      />
      <IntegerRangeFilter name="stock" labelKey={`${baseKey}.stock`} />
      <IntegerRangeFilter
        name="productShippingWarehouseCost"
        labelKey={`${baseKey}.productShippingWarehouseCost`}
      />
      <IntegerRangeFilter
        name="supplier.deliveryDays"
        labelKey={`${baseKey}.supplierDeliveryDays`}
      />
    </FormGroup>
  );
};
